import { useEffect, useState } from "react";
import moment from "moment-timezone";
import "./ServerTime.css";

export default function ServerTime() {
  const [serverTime, setServerTime] = useState(getServerTime());

  function getServerTime() {
    return moment().tz("Asia/Tbilisi").format("MMM D, YYYY HH:mm:ss")
  }

  useEffect(() => {
    const updateCurrentServerTime = () => {
      setServerTime(getServerTime());
    };

    const timer = setInterval(updateCurrentServerTime, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="server-time">
      Server Time: <strong>{serverTime}</strong>
    </div>
  );
}
